import { TaxRate } from '../TaxRate';
export class TaxRateLocalizationBa {
    taxRate;
    constructor(taxRate) {
        this.taxRate = taxRate;
    }
    static getZeroTaxRate() {
        return TaxRate.all().find(taxRate => taxRate.label === 'K' && +taxRate.rate === 0);
    }
    static getTaxesDisabledTaxRate() {
        return TaxRate.all().find(taxRate => taxRate.label === 'A' && +taxRate.rate === 0);
    }
}
const TaxRateLocalizationBaStatic = TaxRateLocalizationBa;
//# sourceMappingURL=TaxRateLocalizationBa.js.map